// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Input_input-container__G5WfB {
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: relative;
}
.Input_input-container--no-border__46PgB {
  margin-bottom: unset;
}
.Input_input-container--no-border__46PgB .Input_input-container__input__c37QN {
  border-color: transparent;
  padding-left: 30px;
  padding-right: 30px;
}
.Input_input-container__input__c37QN {
  width: 100%;
  height: 40px;
  border: var(--m-default-border);
  padding: 0 10px;
  border-radius: var(--m-border-radius);
  outline: none;
  transition: var(--m-transition-fast);
  background-color: var(--m-sidebar-background-color);
  color: var(--m-text);
  padding-left: 30px;
  padding-right: 30px;
}
.Input_input-container__input__c37QN:focus {
  border-color: var(--m-primary);
  padding-left: 30px;
  padding-right: 30px;
}
.Input_input-container__input__c37QN:not([disabled]):not(.Input_input-container__input--valid__YR\\+c7):not(.Input_input-container__input--invalid__ObpAT):hover:not(:focus) {
  background-color: #f8f8f9;
}
.Input_input-container__input__c37QN::placeholder {
  color: var(--m-text-light);
}
.Input_input-container__input--valid__YR\\+c7 {
  border-color: var(--m-success-xbolder);
  padding-right: 30px;
}
.Input_input-container__input--invalid__ObpAT {
  border-color: var(--m-danger-xbolder);
  padding-right: 30px;
}
.Input_input-container__input--icon-before__WwYUp {
  padding-left: 32px;
}
.Input_input-container__input--icon-after__1xfJ2 {
  padding-right: 32px;
}
.Input_input-container__input-icons__RXF4D {
  position: absolute;
  right: 10px;
}
.Input_input-container__input-icons--valid__2sG05 {
  color: var(--m-success-xbolder);
}
.Input_input-container__input-icons--invalid__kh5MO {
  color: var(--m-danger-xbolder);
}
.Input_input-container__use-icon__Qlxhp {
  position: absolute;
  top: 41px;
  font-size: 18px;
  color: #757575;
  display: flex;
  align-items: center;
}
.Input_input-container__use-icon--left__uF7qd {
  left: 10px;
}
.Input_input-container__use-icon--right__RRNA\\+ {
  right: 10px;
}
.Input_input-container__label__JoCJ2 {
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  color: var(--m-text);
}
.Input_input-container__label--required__B6A67 {
  color: var(--m-danger);
  padding-left: 3px;
}
.Input_input-container__message__PKoBl {
  position: absolute;
  bottom: 0;
  margin-bottom: -25px;
  font-size: 13px;
}
.Input_input-container__message--valid__BnuUm {
  color: var(--m-success-xbolder);
}
.Input_input-container__message--invalid__kA28h {
  color: var(--m-danger-xbolder);
}
.Input_input-container__G5WfB .Input_input-icon__OnpgI {
  position: absolute;
  width: fit-content;
  display: flex;
  align-items: center;
}
.Input_input-container__G5WfB .Input_input-icon--before__j\\+CFu {
  left: 8px;
}
.Input_input-container__G5WfB .Input_input-icon--after__Dvjqu {
  right: 8px;
}

[m-data-theme=dark] .Input_input-container__input__c37QN:not([disabled]):not([m-data-theme=dark] .Input_input-container__input--valid__YR\\+c7):not([m-data-theme=dark] .Input_input-container__input--invalid__ObpAT):hover:not(:focus) {
  background-color: rgba(255, 255, 255, 0.03);
}`, "",{"version":3,"sources":["webpack://./src/components/BaseUI/Input/Input.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EAEA,kBAAA;AAAF;AAEE;EACE,oBAAA;AAAJ;AAEI;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;AAAN;AAIE;EACE,WAAA;EACA,YAAA;EACA,+BAAA;EACA,eAAA;EACA,qCAAA;EACA,aAAA;EACA,oCAAA;EACA,mDAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;AAFJ;AAGI;EACE,8BAAA;EACA,kBAAA;EACA,mBAAA;AADN;AAKM;EACE,yBAAA;AAHR;AAuBI;EACE,0BAAA;AATN;AAYI;EACE,sCAAA;EACA,mBAAA;AAVN;AAaI;EACE,qCAAA;EACA,mBAAA;AAXN;AAcI;EACE,kBAAA;AAZN;AAeI;EACE,mBAAA;AAbN;AAiBE;EACE,kBAAA;EACA,WAAA;AAfJ;AAiBI;EACE,+BAAA;AAfN;AAkBI;EACE,8BAAA;AAhBN;AAoBE;EACE,kBAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;AAlBJ;AAoBI;EACE,UAAA;AAlBN;AAqBI;EACE,WAAA;AAnBN;AAuBE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;AArBJ;AAuBI;EACE,sBAAA;EACA,iBAAA;AArBN;AAyBE;EACE,kBAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;AAvBJ;AAyBI;EACE,+BAAA;AAvBN;AA0BI;EACE,8BAAA;AAxBN;AA4BE;EACE,kBAAA;EAGA,kBAAA;EACA,aAAA;EACA,mBAAA;AA1BJ;AA4BI;EACE,SAAA;AA1BN;AA6BI;EACE,UAAA;AA3BN;;AAoCQ;EACE,2CAAA;AAjCV","sourcesContent":[".input-container {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  // margin-bottom: 16px;\n  position: relative;\n\n  &--no-border {\n    margin-bottom: unset;\n\n    .input-container__input {\n      border-color: transparent;\n      padding-left: 30px;\n      padding-right: 30px;\n    }\n  }\n\n  &__input {\n    width: 100%;\n    height: 40px;\n    border: var(--m-default-border);\n    padding: 0 10px;\n    border-radius: var(--m-border-radius);\n    outline: none;\n    transition: var(--m-transition-fast);\n    background-color: var(--m-sidebar-background-color);\n    color: var(--m-text);\n    padding-left: 30px;\n    padding-right: 30px;\n    &:focus {\n      border-color: var(--m-primary);\n      padding-left: 30px;\n      padding-right: 30px;\n    }\n\n    &:not([disabled]):not(&--valid):not(&--invalid) {\n      &:hover:not(:focus) {\n        background-color: #f8f8f9;\n      }\n    }\n\n    &::-webkit-input-placeholder {\n      color: var(--m-text-muted);\n    }\n\n    &::-moz-placeholder {\n      color: var(--m-text-light);\n    }\n\n    &:-ms-input-placeholder {\n      color: var(--m-text-light);\n    }\n\n    &::-ms-input-placeholder {\n      color: var(--m-text-light);\n    }\n\n    &::placeholder {\n      color: var(--m-text-light);\n    }\n\n    &--valid {\n      border-color: var(--m-success-xbolder);\n      padding-right: 30px;\n    }\n\n    &--invalid {\n      border-color: var(--m-danger-xbolder);\n      padding-right: 30px;\n    }\n\n    &--icon-before {\n      padding-left: 32px;\n    }\n\n    &--icon-after {\n      padding-right: 32px;\n    }\n  }\n\n  &__input-icons {\n    position: absolute;\n    right: 10px;\n\n    &--valid {\n      color: var(--m-success-xbolder);\n    }\n\n    &--invalid {\n      color: var(--m-danger-xbolder);\n    }\n  }\n\n  &__use-icon {\n    position: absolute;\n    top: 41px;\n    font-size: 18px;\n    color: #757575;\n    display: flex;\n    align-items: center;\n\n    &--left {\n      left: 10px;\n    }\n\n    &--right {\n      right: 10px;\n    }\n  }\n\n  &__label {\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 16px;\n    color: var(--m-text);\n\n    &--required {\n      color: var(--m-danger);\n      padding-left: 3px;\n    }\n  }\n\n  &__message {\n    position: absolute;\n    bottom: 0;\n    margin-bottom: -25px;\n    font-size: 13px;\n\n    &--valid {\n      color: var(--m-success-xbolder);\n    }\n\n    &--invalid {\n      color: var(--m-danger-xbolder);\n    }\n  }\n\n  .input-icon {\n    position: absolute;\n    width: -webkit-fit-content;\n    width: -moz-fit-content;\n    width: fit-content;\n    display: flex;\n    align-items: center;\n\n    &--before {\n      left: 8px;\n    }\n\n    &--after {\n      right: 8px;\n    }\n  }\n}\n\n[m-data-theme=\"dark\"] {\n  .input-container {\n    &__input {\n      &:not([disabled]):not(&--valid):not(&--invalid) {\n        &:hover:not(:focus) {\n          background-color: rgba($color: #fff, $alpha: 0.03);\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input-container": `Input_input-container__G5WfB`,
	"input-container--no-border": `Input_input-container--no-border__46PgB`,
	"input-container__input": `Input_input-container__input__c37QN`,
	"input-container__input--valid": `Input_input-container__input--valid__YR+c7`,
	"input-container__input--invalid": `Input_input-container__input--invalid__ObpAT`,
	"input-container__input--icon-before": `Input_input-container__input--icon-before__WwYUp`,
	"input-container__input--icon-after": `Input_input-container__input--icon-after__1xfJ2`,
	"input-container__input-icons": `Input_input-container__input-icons__RXF4D`,
	"input-container__input-icons--valid": `Input_input-container__input-icons--valid__2sG05`,
	"input-container__input-icons--invalid": `Input_input-container__input-icons--invalid__kh5MO`,
	"input-container__use-icon": `Input_input-container__use-icon__Qlxhp`,
	"input-container__use-icon--left": `Input_input-container__use-icon--left__uF7qd`,
	"input-container__use-icon--right": `Input_input-container__use-icon--right__RRNA+`,
	"input-container__label": `Input_input-container__label__JoCJ2`,
	"input-container__label--required": `Input_input-container__label--required__B6A67`,
	"input-container__message": `Input_input-container__message__PKoBl`,
	"input-container__message--valid": `Input_input-container__message--valid__BnuUm`,
	"input-container__message--invalid": `Input_input-container__message--invalid__kA28h`,
	"input-icon": `Input_input-icon__OnpgI`,
	"input-icon--before": `Input_input-icon--before__j+CFu`,
	"input-icon--after": `Input_input-icon--after__Dvjqu`
};
export default ___CSS_LOADER_EXPORT___;
